<template>
  <div class="col-sm-12 form-data nopads" @click.stop="null">
    <div v-if="trafficControlItemUpdate" class="row nopads">
      <div class="col-sm-6 nopads pr-1">
          <span class="span-title">
            {{ $t('traffic_control.start_time') }}
          </span>
          <input
              id="start"
              :value="timestampToDateInput(trafficControlItemUpdate.start_time)"
              type="date"
              class="form-control form-control-sm"
              @blur="updateStartTime"
          />
      </div>
      <div class="col-sm-6 nopads pr-1">
          <span class="span-title">
            {{ $t('traffic_control.end_time') }}
          </span>
          <input
              id="end"
              :value="timestampToDateInput(trafficControlItemUpdate.end_time)"
              type="date"
              class="form-control form-control-sm"
              @blur="updateEndTime"
          />
      </div>
    </div>
    <div class="col-12">
      <open-contract-filter
        :from="now"
        :show-only-my-contracts-option="true"
        :contract="contract"
        :show-title="true"
        :show-company="false"
        @contract-selected="setContract"
      />
    </div>
    <div class="col-sm-12 nopads">
        <span class="span-title">{{ $t('common.description') }}</span>
        <textarea
            id="description"
            v-model="description"
            rows="4"
            class="form-control form-control-sm"
            :placeholder="$t('common.description')"
            style="resize: none;"
        ></textarea>
    </div>
    <div class="col-sm-12 button-container pt-2 pb-0 mb-0">
      <button
        class="btn btn-secondary form-button"
        @click.stop="$emit('close')"
      >
        {{ $t('common.cancel') }}
      </button>
      <button
        class="btn btn-success form-button"
        @click.stop="submitTrafficControl"
      >
        {{ $t('common.save') }}
      </button>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>

import {restApi} from '@/components/mixins/RestApiMixin'

import OpenContractFilter from "@/components/contract/OpenContractFilter.vue";
import {inject, toRaw} from "vue";

export default {
    name: "TrafficControlEditor",
    components: {
        OpenContractFilter
    },
    mixins: [
        restApi,
    ],
    props: {
        trafficControlItem: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            loading: false,
            trafficControlItemUpdate: null,
            description: '',
            contract: null
        }
    },
    computed: {
        now() {
            return new Date().toISOString();
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    mounted() {
        this.trafficControlItemUpdate = JSON.parse(JSON.stringify(toRaw(this.trafficControlItem)))
        this.description = this.trafficControlItemUpdate.description ? this.trafficControlItemUpdate.description : ""
        this.contract = this.trafficControlItemUpdate.contract && this.trafficControlItemUpdate.contract.id ? this.trafficControlItemUpdate.contract : null
    },
    methods: {
        submitTrafficControl: function () {
            var json = this.setDefaultValues(this.trafficControlItemUpdate)
            if (json !== undefined) {
                this.loading = true
                if (!json.id || json.id < 1) {
                    this.restAdd(this.trafficControlUrl, json, this.success, this.fail)
                } else {
                    this.restUpdate(this.trafficControlUrl, json, this.success, this.fail)
                }
            }
        },
        setDefaultValues: function (trafficControlItemUpdate) {
            let trafficControlItem = JSON.parse(JSON.stringify(trafficControlItemUpdate))
            trafficControlItem.contract = this.contract
            if (trafficControlItem.start_time && (trafficControlItem.start_time instanceof Date)) {
                trafficControlItem.start_time = trafficControlItem.start_time.toISOString()
            }
            if (trafficControlItem.end_time && (trafficControlItem.end_time instanceof Date)) {
                trafficControlItem.end_time = trafficControlItem.end_time.toISOString()
            }
            trafficControlItem.description = this.description
            return trafficControlItem
        },
        success: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_success'), 'success')
            this.$emit('closeAndUpdate')
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        },
        updateStartTime(event) {
            const dateString = event.target.value; // 'YYYY-MM-DD' format
            if (dateString) {
                // Convert 'YYYY-MM-DD' to a Date
                this.trafficControlItemUpdate.start_time = new Date(dateString);
            } else {
                this.trafficControlItemUpdate.start_time = undefined;
            }
        },
        updateEndTime(event) {
            const dateString = event.target.value; // 'YYYY-MM-DD' format
            if (dateString) {
                // Convert 'YYYY-MM-DD' to a Date
                this.trafficControlItemUpdate.end_time = new Date(dateString);
            } else {
                this.trafficControlItemUpdate.end_time = undefined;
            }
        },
        setContract(contract) {
            this.contract = contract ? contract : null
        }
    }
}

</script>

<style>
@import "../../styles/modal.css";
</style>
